module.exports = __webpack_public_path__ + "img/EMS_user_manual5.fbf949b2.png";